export default "__VITE_PUBLIC_ASSET__bc3db745__"